import type { FaireProductEntity } from "../../entity_types/product";

export const p_nnnyr6unuq: FaireProductEntity = {
  token: "p_nnnyr6unuq",
  type: "product",
  name: "Clique Tempo Eco Stretch Full Zip Womens Softshell Jacket",
  brandToken: "b_9nsfnkqwuw",
  brandName: "Cutter & Buck",
  imageUrl:
    "https://cdn.faire.com/fastly/a9985d9c824cf4861072b45751327f7906b20708dbb15ea6bc48db3759f49f69.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/3ea3bc073189e222ba0b9d6c7084787696c7b784c7f77c0861c2096e63cf7a8c.jpeg",
    "https://cdn.faire.com/fastly/4d9b0ae902834f0962467a57573fde0bf197d78bd73afb89faf1652dee36e000.jpeg",
    "https://cdn.faire.com/fastly/80265fa2b3bb001e0dfe2ae2d9212c2e8fee9ebc8ac7212dfb42681db964e193.jpeg",
    "https://cdn.faire.com/fastly/25699ab05b80bac5b47d419499e09857f4d7e5da7b82a34a2ef4ea74e5284579.jpeg",
  ],
  priceDollars: 29,
  description:
    "Made from 26 GRS certified post-consumer recycled plastic bottles, the Clique Tempo Eco Stretch Full Zip Womens Softshell Jacket is a sporty everyday water-repellent jacket perfect for mild precipitation and windy conditions, for work and for representing your school, college, team or company. This must have PFAS free water-repellent finished eco jacket is constructed with a recycled polyester and spandex stretch for all day performance, warmth and comfort. The year-round, OEKO-TEX certified, eco jacket favorite includes a contrast zippered full zip and two zippered on-seam pockets to keep your valuables secure.\n\nPFAS free water repellent finish\nFlexible bonded fleece layer\nContrast color full zipper with secure zippered hand pockets",
  tags: [],
  msrpDollars: 65,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-06T18:02:08.350Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
